export default function ImpressumV2() {
  return (
    <div className="min-h-screen text-[var(--text)]">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="bg-white/85 backdrop-blur-sm rounded-2xl p-6 shadow-sm space-y-4 text-sm">
        <h1 className="text-2xl font-semibold mb-2">Impressum</h1>
        <p className="text-[var(--muted)]">
          Angaben gemäß den gesetzlichen Informationspflichten für CarmaCircle.
        </p>

        <div className="space-y-1">
          <h2 className="text-sm font-medium">Verantwortlich für den Inhalt</h2>
          <p>Daniel Sesay</p>
          <p>60389 Frankfurt</p>
          <p>
            E-Mail: <a href="mailto:beta@carmacircle.org" className="underline">beta@carmacircle.org</a>
          </p>
        </div>

        <p className="text-[var(--muted)] text-xs pt-2">
          Hinweis: Diese Angaben werden bei Änderungen rechtzeitig aktualisiert.
        </p>
        </div>
      </div>
    </div>
  );
}
